import { render, staticRenderFns } from "./TerminosItem.vue?vue&type=template&id=ee3856be&scoped=true&"
import script from "./TerminosItem.vue?vue&type=script&lang=js&"
export * from "./TerminosItem.vue?vue&type=script&lang=js&"
import style0 from "./TerminosItem.vue?vue&type=style&index=0&id=ee3856be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3856be",
  null
  
)

export default component.exports